













































































































































































































































































































































import {
    Component,
    Vue
} from 'vue-property-decorator'

@Component
export default class LinearGraph extends Vue {
    public unloaded: number = 0;

    data() {
        return {
            
        }
    }
    mounted() {
        this.unloaded = 1;
    }

    graphHover(event: Event) {
        const target = event.target as HTMLElement;
        const child = target.firstChild as HTMLElement;
        const tooltip = target.children[1] as HTMLElement;

        if (child !== null) {
            if (!child.classList.contains("is-visible")) {
                child.classList.add("is-visible");
                tooltip.classList.add("is-visible");
            } else {
                child.classList.remove("is-visible");
                tooltip.classList.remove("is-visible");
            }
        }
    }

    mouseMove(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const tooltip = target.children[1] as HTMLElement;

        tooltip.style.top = (event.offsetY + 25) + 'px';
        tooltip.style.left = (event.offsetX) + 'px';
    }
}
